import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

// Agar aap aage chal kar GSAP use karte hain, toh inko uncomment kar lijiye ga:
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);

export default function SmoothScrollWrapper({ children }) {
  useEffect(() => {
    // 1. Nayi aur zyada smooth settings ke sath Lenis initialize karein
    const lenis = new Lenis({
      duration: 1.9,             // Default (1.2) se badha kar 2.5 kiya for extra buttery feel
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothWheel: true,         // Wheel scroll ko smooth banata hai
      wheelMultiplier: 1.5,      // Scroll ki speed (1.2 Apple-like feel ke liye best hai)
      infinite: false,           // Page ke end par scroll rokne ke liye
    });

    // 2. Request Animation Frame (RAF) setup
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const rafId = requestAnimationFrame(raf);

    // --- Optional: GSAP ScrollTrigger Sync ---
    // Agar aap GSAP Scroll Animations use karte hain, toh niche wala code uncomment karein:

    // lenis.on('scroll', ScrollTrigger.update);
    // gsap.ticker.add((time) => {
    //   lenis.raf(time * 1000);
    // });
    // gsap.ticker.lagSmoothing(0);

    // ------------------------------------------

    // 3. Cleanup function (Memory leaks rokne ke liye)
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return <>{ children }</>;
}